import React from 'react'
import './Chat.css'
import { useParams } from 'react-router-dom'
import StarBorderIcon from '@mui/icons-material/StarBorder';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useEffect, useState, useRef } from 'react'
import db from './firebase';
import Message from './Message';
import ChatInput from './ChatInput';



function Chat() {
  const { roomId } = useParams()
  const [roomDetails, setRoomDetails]  = useState(null)
  const [roomMessages, setRoomMessages] = useState([])
  
  const chatRef = useRef(null)

// anything roomId changes, we need to rerender Chat to that chatroom's content
  useEffect(() => {
    if (roomId) {
      db.collection('rooms').doc(roomId).onSnapshot(snapshot => ( 
          setRoomDetails(snapshot.data())
      )) 
      }
      db.collection('rooms').doc(roomId).collection('messages').orderBy('timestamp' , 'asc').onSnapshot((snapshot) =>
      setRoomMessages(snapshot.docs.map(doc => doc.data()))
      )
    }, [roomId])
    
    useEffect(() => {
      
      // scrollIntoView was moving the whole page without these params
      chatRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
   }, [roomMessages])

console.log(roomMessages)

   return (
    <div className='chat'>
      <div className="chat__header">
          <div className="chat__headerLeft">
            <h4 className="chat__channelName">
              <strong># {roomDetails?.name}</strong>
              <StarBorderIcon />
            </h4>
          </div>
          <div className="chat__headerRight">
            <p>
            <InfoOutlinedIcon /> Details 
            </p>
          </div>
      </div>

      
      <div className="chat__messages"> 
      {roomMessages.map(({messages, timestamp, user, userImage}) => (
      <Message 
      messages={messages}
      timestamp={timestamp}
      user={user}
      userImage={userImage}
      />
      ))
    }
  
    <div ref={chatRef}></div>
      </div>
       
    


      <ChatInput channelName={roomDetails?.name} channelId={roomId} />
    </div>
  )
}

export default Chat